module.exports = __webpack_public_path__ + "static/media/rice_end.4fdaba87.jpg";